import React from 'react';
import LvnWelcomeLetter from '../../components/Lvn/LvnWelcomeLetter';
import RnWelcomeLetter from '../../components/RN/RnWelcomeLetter';
import PtWelcomeLetter from '../../components/PT/PtWelcomeLetter';
import PtaWelcomLetter from '../../components/PTA/PtaWelcomLetter';
import OtaWelcomeLetter from '../../components/OTA/OtaWelcomeLetter';
import OtWelcomeLetter from '../../components/OT/OtWelcomeLetter';
import HhaWelcomeLetter from '../../components/HHA/HhaWelcomeLetter';
import MswWelcomeLetter from '../../components/MSW/MswWelcomeLetter';
import StWelcomeLetter from '../../components/St/StWelcomeLetter';

// Dictionary of Welcome Letters by Position
const WELCOME_LETTERS = {
    'lvn': LvnWelcomeLetter,
    'rn': RnWelcomeLetter,
    'pt': PtWelcomeLetter,
    'pta': PtaWelcomLetter,
    'ota': OtaWelcomeLetter,
    'st': StWelcomeLetter,
    'ot': OtWelcomeLetter,
    'hha': HhaWelcomeLetter,
    'msw': MswWelcomeLetter,
    // Add other positions here as needed
};

const WelcomeLetterRenderer = ({ positionId, positionName, targetUserId, onClose }) => {
    // Get the component based on positionId, default to RN if not found? 
    // Or return null if not supported
    const Component = WELCOME_LETTERS[positionId];

    if (!Component) {
        // Fallback: If no specific component, perhaps render a generic one or null
        // The ApplicationForm will handle other cases, but the user wants "always render this"
        // Let's return null so ApplicationForm can show its default or nothing
        return null;
    }

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-100">
            <Component positionName={positionName} targetUserId={targetUserId} onClose={onClose} />
        </div>
    );
};

export default WelcomeLetterRenderer;
